import React, { useState, } from 'react';
import { mapValues } from 'lodash';
import fileDownload from 'js-file-download';
import { unparse as unparseCsv, } from 'papaparse';
import { isFunction } from 'lodash';
import classnames from 'classnames';
import { Button, } from 'reactstrap';

import useLocale from './hooks/useLocale';
import useCompany from './hooks/useCompany';
import useQueryParams from './hooks/useQueryParams';
import { encode } from '../util';
import { exportFileName } from '../utils';

export default function ExportButton ({ fileName, screenName, targetCompany, withoutYearMonth = false, label = 'エクスポート', rows, encoding = 'UTF8_BOM', ...extraProps }) {
  const [isExporting, setIsExporting] = useState(false);
  const { translate } = useLocale();
  const company = useCompany();
  const { yearMonth } = useQueryParams();

  const generateFileName = () => {
    if(fileName != null) return translate(fileName);

    // NOTE: 会社名は翻訳対象外なので、画面名だけ翻訳してから組み立てる
    const _company = targetCompany || company;
    const companyName = _company?.display_name || _company?.name;
    return exportFileName(translate(screenName), companyName, withoutYearMonth ? null : yearMonth);
  };

  const onClickExport = async () => {
    setIsExporting(true);
    const _rows = isFunction(rows) ? (await rows()) : rows;
    const text = unparseCsv(_rows.map(_ => mapValues(_, v => translate(typeof v === 'number' ? Math.round(v * 100) / 100 : v))));
    const fileContent = encode(text, encoding);
    fileDownload(fileContent, generateFileName());
    setIsExporting(false);
  };

  return (
    <Button color="secondary" onClick={onClickExport} disabled={isExporting} {...extraProps}>
      <span className={classnames('fas mr-1', { 'fa-spin fa-spinner': isExporting, 'fa-download': !isExporting })} />
      {label}
    </Button>
  );
};
